import api from '@/api'

export default {
  async getSite(context, payload) {
    const organizationId = payload?.organizationId
    const siteId = payload?.siteId
    const response = await api.site.getById(organizationId, siteId)

    return response
  },

  async updateSite(context, payload) {
    const response = await api.site.updateOrganizationSite(
      payload.organizationId,
      payload.siteId,
      payload.site
    )

    return response
  },
}
